import React from 'react'
import * as Dropdown from 'component/base/Form/Dropdown'

export const KosokuRiyo = props => {
  return <Dropdown.Static kubunKey='kosoku_riyo' {...props} />
}
